
import MainMenu from './includes/MainMenu.vue';

export default {
    components: {
        MainMenu,
    }
}
